/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['modal'] }] */
import React, { useCallback, useState } from 'react';
import cn from 'classnames';

import { evSearchCrossSiteRecoClick } from 'events/recommendations';
import { track } from 'apis/amethyst';
import useMartyContext from 'hooks/useMartyContext';
import { capitalize, constructMSAImageUrl } from 'helpers';
import MelodyCarousel from 'components/common/MelodyCarousel';

import css from 'styles/components/search/crossSiteProducts.scss';

const PRODUCT_IMAGE_SIZE = 450;
const MSA_IMAGE_DIMENSION = { width: PRODUCT_IMAGE_SIZE, height: PRODUCT_IMAGE_SIZE };

const useCrossSite = (product, fetchProductDetail) => {
  const { testId, marketplace: { name } } = useMartyContext();
  const [data, setData] = useState(null);

  const handleClickCard = useCallback(e => {
    e.preventDefault();
    track(() => ([
      evSearchCrossSiteRecoClick, { product }
    ]));
    fetchProductDetail(product, { includeOos: true, errorOnOos: false }).then(response => {
      const respData = { ...product, ...response };
      setData(respData);
    });
  }, [product, fetchProductDetail]);

  const handleClickStay = useCallback(product => {
    track(() => ([
      evSearchCrossSiteRecoClick, { product, proceedToTrustedRetailer: false }
    ]));
    setData(null);
  }, []);

  const handleClickContinue = useCallback(product => {
    track(() => ([
      evSearchCrossSiteRecoClick, { product, proceedToTrustedRetailer: true }
    ]));
    setData(null);
  }, []);

  const makeProductImage = () => {
    const classes = { itemsContainer: css.itemsContainer, fullHeight: css.fullHeight };
    const arrowStyleOverrides = { top: '50%' };
    const imageUrls = data.styles.find(v => v.styleId === data.styleId) || { images: [{ imageId: data.thumbnailImageUrl }] };
    const images = imageUrls.images.map((i, k) => <div key={k} className={cn(css.imageContainer)}>
      <img src={constructMSAImageUrl(i.imageId, MSA_IMAGE_DIMENSION)} alt={i.imageId} />
    </div>);
    return <MelodyCarousel classes={classes} arrowStyleOverrides={arrowStyleOverrides}>
      {images}
    </MelodyCarousel>;
  };

  const makeContent = () => {
    if (!data) {
      return null;
    }
    const { storeUrl, storeName, productSeoUrl } = data;
    return (
      <>
        <section className={css.modalCarousel}>{makeProductImage(data)}</section>
        <section className={css.modalContent}>
          <h2>En Voyage to <span className={css.uppercase}>{storeName}</span>.com</h2>
          <p>
            <a className={css.uppercase} href={storeUrl}>{storeName}</a> offers modern luxury with a playful twist.
          </p>
          <p>Login with your Zappos username and password.</p>
          <div className={css.modalBtnContainer}>
            <button
              data-test-id={testId('searchResultsCrossSiteModalStay')}
              type="button"
              className={css.btnStay}
              onClick={() => handleClickStay(data)}>
              Stay on {capitalize(name)}
            </button>
            <a
              onClick={() => handleClickContinue(data)}
              data-test-id={testId('searchResultsCrossSiteModalContinue')}
              className={css.btnContinue}
              href={productSeoUrl}
              target="_blank"
              rel="noopener noreferrer">
              Continue to {storeName}
            </a>
          </div>
        </section>
      </>
    );
  };

  return { onClick: product.storeName ? handleClickCard : null, closeClick: handleClickStay, content: makeContent(), visible: !!data };
};

export default useCrossSite;
